/*
  - Code to Change existing password
  - Commented by Sarthak on Feb 12, 2024
  */

import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { Router, ActivatedRoute, NavigationExtras } from "@angular/router";
import { ValidationService } from "../../../app/validation.service";
import {
  AbstractControl,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { AuthenticationServiceService } from "../../../app/authentication-service.service";
import { ChangeUsersService } from "../../../app/services/change-users.service";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { from } from "rxjs";
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { CommonModule } from "@angular/common";
import { ControlMessagesComponent } from "../../../app/control-messages.component";
import { MatButtonModule } from "@angular/material/button";
@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,CommonModule,ControlMessagesComponent, MatButtonModule]
})
export class ChangePasswordComponent implements OnInit {
  public updatePasswordUrl = BaseUrlConstantsService.UPDATEPASSWORD;
  public hasErrors: Boolean = false;
  public errorMessage = "";
  public loginErrorCode = "";
  public loginErrorMessage = "";
  public username = "";
  public password = "";
  public userForm: any;
  public role: any;
  public msgInfo: string = "";
  public pageRef: any;
  public returnUrl: string;
  public email: string;
  public customer: any;
  public emailBoxMain: boolean = true;
  public resetPasswordBoxMain: boolean = false;
  public emailID: string;
  public company_name: string;
  public today: Date;
  constructor(
    private router: Router,
    public service: BackendApiService,
    public changeUserDashboard: ChangeUsersService,
    private authenticationService: AuthenticationServiceService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder
  ) {
    this.company_name = localStorage.getItem("company_name");
    this.utcTime();
  }
  /*
    - this function return the complete day-date-time and timezone of current user and save the value to this.today variable
    - this.today is not used anywhere yet
    - Commented by Sarthak on Feb 12, 2024
  */
  utcTime() {
    setInterval(() => {
      const date = new Date().getHours();
      const houre = new Date().getMinutes();
      const second = new Date().getSeconds();
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }
  /*
    - Routes user to https://dev.enertics.ca/#/login
    - Commented by Sarthak on Feb 12, 2024
  */
  goToLogin() {
    this.router.navigate(["login"]);
  }
  /*
     - Gets user_id from local storage and sets password to new password
     - This function updates new password of user and displays result as success or failure message on updating password
     - Commented by Sarthak on Feb 12, 2024
  */
  resetPassword() {
    var body = {
      id: localStorage.getItem("user_id"),
      password: this.userForm.value.new_password,
    };
    if (
      this.userForm.value.new_password === this.userForm.value.confirm_password
    ) {
      this.msgInfo = "";
      this.changeUserDashboard.loader(true);
      this.service
        .postDataSigin(this.updatePasswordUrl, body)
        .then((response) => {
          this.changeUserDashboard.loader(false);
          var status = JSON.parse(JSON.stringify(response)).data.status;
          if (status === "success") {
            this.service.showSuccess("Password Updated");
            this.ngOnInit();
          } else {
            this.service.showError("Error while updating password.");
          }
        });
    } else {
      this.msgInfo = "Password does not match.";
    }
  }
  /*
    - If user does not want to update password he is redirected back to route specific to Role of user
    - If Admin is logged in then redirected to https://dev.enertics.ca/#/admin-dashborad
    - Else User is redirected to https://dev.enertics.ca/#/device-reports
    - Commented by Sarthak on Feb 12, 2024
  */
  cancelback() {
    const navigationExtras = {};
    if (localStorage.getItem("role") == "ADMIN") {
      this.router.navigate(["/admin-dashboard"], navigationExtras);
    } else {
      this.router.navigate(["/device-reports"], navigationExtras);
    }
  }
  /*
      - On rendering the component for first time creates userForm having values new_password and Confirm_password set to an empty string
      - Commented by Sarthak on Feb 12, 2024
   */
  ngOnInit() {
    this.userForm = this.formBuilder.group({
      new_password: [
        "",
        [Validators.required, ValidationService.passwordValidator],
      ],
      confirm_password: ["", [Validators.required]],
    });
  }
  /*
    - Routes to undefined
    - Route isn't created yet to register a new user
    - Commented by Sarthak on Feb 12, 2024
  */
  async signupScreen() {
    this.router.navigate(["/auth/register"]);
  }
  /*
    - Routes to https://dev.enertics.ca/#/forgot-password
    - Commented by Sarthak on Feb 12, 2024
  */
  goToForgotPassword() {
    this.router.navigate(["forgot-password"]);
  }
}
